<template>
    <div class="xc-page reset xc-page-sandwich">
        <div class="xc-page-main">
            <div class="xc-breadcrumb">
                <router-link :to="$config.adminPath + '/system/user'">系统设置</router-link>
                <a>用户管理</a>
            </div>
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <form
                            class="xc-form"
                            name="search"
                            @submit.prevent="mix_search"
                        >
                            <div class="xc-form-inline">
                                <xc-form-item label="所属部门:">
                                    <select
                                        name="departmentId"
                                        class="xc-select"
                                        v-model="mix_query.departmentId"
                                    >
                                        <option value="">全部</option>
                                        <template v-if="departments && departments.length">
                                            <option
                                                v-for="(item,index) in departments"
                                                :key="index"
                                                :value="item.departmentId"
                                            >
                                                {{item.departmentName}}
                                            </option>
                                        </template>
                                    </select>
                                </xc-form-item>
                                <xc-form-item label="角色名称:">
                                    <input
                                        type="text"
                                        name="roleName"
                                        v-model="mix_query.roleName"
                                        class="xc-input"
                                        placeholder="请输入角色名称"
                                    >
                                </xc-form-item>
                                <xc-form-item label="账号:">
                                    <input
                                        type="text"
                                        name="userName"
                                        v-model="mix_query.userName"
                                        class="xc-input"
                                        placeholder="请输入账号"
                                    >
                                </xc-form-item>
                                <xc-form-item label="姓名:">
                                    <input
                                        type="text"
                                        name="realName"
                                        v-model="mix_query.realName"
                                        class="xc-input"
                                        placeholder="请输入姓名"
                                    >
                                </xc-form-item>
                            </div>
                            <div class="xc-form-inline">
                                <xc-form-item label="手机号码:">
                                    <input
                                        type="tel"
                                        name="mobile"
                                        v-model="mix_query.mobile"
                                        class="xc-input"
                                        placeholder="请输入电话号码"
                                    >
                                </xc-form-item>
                                <div class="xc-btn-group">
                                    <button
                                        type="submit"
                                        class="xc-btn xc-btn-primary"
                                    >查询
                                    </button>
                                    <button
                                        class="xc-btn xc-btn-default"
                                        type="button"
                                        @click="add"
                                    >添加
                                    </button>
                                </div>
                            </div>
                        </form>
                        <table class="xc-table">
                            <thead>
                                <tr>
                                    <th>账号</th>
                                    <th>姓名</th>
                                    <th>部门名称</th>
                                    <th>手机号码</th>
                                    <th>角色名称</th>
                                    <!-- <th>创建时间</th> -->
                                    <th>最后登录时间</th>
                                    <th>最后登录IP</th>
                                    <th>最后操作时间</th>
                                    <th>账户状态</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr
                                        v-for="(item,index) in list"
                                        :key="index"
                                    >
                                        <td>{{item.userName}}</td>
                                        <td>{{item.realName}}</td>
                                        <td>{{item.departmentName}}</td>
                                        <td>{{item.mobilePhone}}</td>
                                        <td>{{item.belongRole}}</td>
                                        <!-- <td>{{item.addTime}}</td> -->
                                        <td>{{item.lastLoginTime}}</td>
                                        <td>{{item.lastLoginIp}}</td>
                                        <td>{{item.updateTime}}</td>
                                        <td>{{item.status | getStatus}}</td>
                                        <td>
                                            <xc-btn-select
                                                title="管理"
                                                v-if="item.userName!='superadmin' && item.belongRoleIds != 2"
                                            >
                                                <template v-if="groups(item).length">
                                                    <xc-btn-select-item
                                                        v-for="(obj,key) in groups(item)"
                                                        :key="key"
                                                        :title="obj.name"
                                                        @click.native="mix_action(obj,item,$event)"
                                                    ></xc-btn-select-item>
                                                </template>
                                            </xc-btn-select>

                                            <xc-btn-select
                                                title="管理"
                                                v-else-if="item.belongRoleIds == 2"
                                            >
                                                <template v-if="powers(item).length">
                                                    <xc-btn-select-item
                                                        v-for="(obj,key) in powers(item)"
                                                        :key="key"
                                                        :title="obj.name"
                                                        @click.native="mix_action(obj,item,$event)"
                                                    ></xc-btn-select-item>
                                                </template>
                                            </xc-btn-select>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td
                                            colspan="20"
                                            class="xc-s-tac"
                                        >暂无数据
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="xc-page-footer">
            <!-- 分页 -->
            <xc-pagination
                @change="pageChange"
                :page="mix_page"
                :total="mix_total"
                :size="mix_pageSize"
            />
        </div>
        <div class="xc-card">
            <!--添加-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='add'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">添加</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName=null"
                            ></div>
                        </div>
                        <div class="xc-modal-body">
                            <form
                                class="xc-form"
                                name="add"
                                data-vv-scope="add"
                            >
                                <div class="xc-form-inline">
                                    <xc-form-item
                                        label="账号:"
                                        required
                                    >
                                        <input
                                            type="text"
                                            name="userName"
                                            class="xc-input"
                                            v-validate="'required'"
                                            data-vv-as="账号"
                                            placeholder="请输入账号"
                                            :class="{'xc-input-error':errors.first('userName','add')}"
                                        >
                                        <div class="xc-form-item-error-tips">
                                            {{errors.first("userName","add")}}
                                        </div>
                                    </xc-form-item>
                                    <xc-form-item
                                        label="姓名:"
                                        required
                                    >
                                        <input
                                            type="text"
                                            name="realName"
                                            class="xc-input"
                                            v-validate="'required'"
                                            data-vv-as="姓名"
                                            placeholder="请输入姓名"
                                            :class="{'xc-input-error':errors.first('realName','add')}"
                                        >
                                        <div class="xc-form-item-error-tips">
                                            {{errors.first("realName","add")}}
                                        </div>
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item
                                        label="手机号码:"
                                        required
                                    >
                                        <input
                                            type="tel"
                                            name="mobilePhone"
                                            class="xc-input"
                                            v-validate="'required|mobile'"
                                            data-vv-as="手机号码"
                                            placeholder="请输入手机号码"
                                            :class="{'xc-input-error':errors.first('mobilePhone','add')}"
                                        >
                                        <div class="xc-form-item-error-tips">
                                            {{errors.first("mobilePhone","add")}}
                                        </div>
                                    </xc-form-item>
                                    <xc-form-item label="部门名称:">
                                        <div class="department">
                                            <input
                                                type="hidden"
                                                name="departmentId"
                                                :value="departmentId"
                                            />
                                            <input
                                                type="text"
                                                name="departmentName"
                                                :value="departmentName"
                                                class="parentName xc-input xc-input-disabled"
                                                disabled
                                                placeholder="请选择上级部门"
                                            />
                                            <span
                                                class="myDepartment"
                                                @click="selectDepartment"
                                            ><i class="fa fa-align-center"></i> </span>
                                        </div>
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item
                                        label="角色名称"
                                        required
                                    >
                                        <v-select
                                            class="xc-input roles"
                                            :options="roles"
                                            v-model="values"
                                            :reduce="roleName => roleName.roleId"
                                            label="roleName"
                                            multiple
                                            placeholder="请选择"
                                            :closeOnSelect="false"
                                        ></v-select>
                                    </xc-form-item>
                                    <xc-form-item
                                        label="是否启用："
                                        required
                                        :error="errors.first('status','add')"
                                    >
                                        <label class="xc-checkbox-wrap">
                                            <input
                                                type="radio"
                                                name="status"
                                                class="xc-radio"
                                                value="1"
                                                v-validate="'required'"
                                                data-vv-as="状态"
                                                :checked="true"
                                            >
                                            <span class="xc-checkbox-label">启用</span>
                                        </label>
                                        <label class="xc-checkbox-wrap">
                                            <input
                                                type="radio"
                                                name="status"
                                                class="xc-radio"
                                                value="0"
                                                v-validate="'required'"
                                                data-vv-as="状态"
                                            >
                                            <span class="xc-checkbox-label">禁用</span>
                                        </label>
                                    </xc-form-item>
                                </div>
                                <xc-form-item
                                    label="密码："
                                    required
                                    :error="errors.first('password','add')"
                                >
                                    <div class="password-input-wrapper">
                                        <input
                                            :type="showAddPassword ? 'text' : 'password'"
                                            name="password"
                                            v-validate="'required|complexPwd'"
                                            data-vv-as="密码"
                                            class="xc-input"
                                            autocomplete="new-password"
                                            :class="{'xc-input-error':errors.first('password','add')}"
                                        />
                                        <span class="password-toggle" @click="showAddPassword = !showAddPassword">
                                            <i class="fa" :class="showAddPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                                        </span>
                                    </div>
                                </xc-form-item>
                                <xc-form-item label="备注:">
                                    <textarea
                                        name="remark"
                                        class="xc-textarea"
                                    ></textarea>
                                </xc-form-item>
                            </form>
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-default"
                                    @click="modalName=null"
                                >取消
                                </button>
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-primary"
                                    @click="addSubmit"
                                >保存
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--编辑-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='edit'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">编辑</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName=null"
                            ></div>
                        </div>
                        <div class="xc-modal-body">
                            <form
                                class="xc-form"
                                name="edit"
                                data-vv-scope="edit"
                            >
                                <div class="xc-form-inline">
                                    <xc-form-item
                                        label="账号:"
                                        required
                                    >
                                        <input
                                            type="text"
                                            name="userName"
                                            class="xc-input xc-input-disabled"
                                            disabled
                                            placeholder="请输入账号"
                                            v-model="current.userName"
                                        >
                                        <input
                                            type="hidden"
                                            name="userId"
                                            v-model="current.userId"
                                        />
                                    </xc-form-item>
                                    <xc-form-item
                                        label="姓名:"
                                        required
                                        :error="errors.first('realName','edit')"
                                    >
                                        <input
                                            type="text"
                                            name="realName"
                                            v-validate="'required'"
                                            data-vv-as="姓名"
                                            class="xc-input"
                                            v-model="current.realName"
                                        >
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item
                                        label="手机号码:"
                                        required
                                        :error="errors.first('mobilePhone','edit')"
                                    >
                                        <input
                                            type="tel"
                                            name="mobilePhone"
                                            v-validate="'required|mobile'"
                                            data-vv-as="手机号码"
                                            class="xc-input "
                                            v-model="current.mobilePhone"
                                        >
                                    </xc-form-item>
                                    <xc-form-item
                                        label="是否启用："
                                        required
                                        :error="errors.first('status','edit')"
                                    >
                                        <label class="xc-checkbox-wrap">
                                            <input
                                                type="radio"
                                                name="status"
                                                v-model="current.status"
                                                class="xc-radio"
                                                value="1"
                                                v-validate="'required'"
                                                data-vv-as="状态"
                                            >
                                            <span class="xc-checkbox-label">启用</span>
                                        </label>
                                        <label class="xc-checkbox-wrap">
                                            <input
                                                type="radio"
                                                name="status"
                                                v-model="current.status"
                                                class="xc-radio"
                                                value="0"
                                                v-validate="'required'"
                                                data-vv-as="状态"
                                            >
                                            <span class="xc-checkbox-label">禁用</span>
                                        </label>
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item label="所属部门:">
                                        <div class="department">
                                            <input
                                                type="hidden"
                                                name="departmentId"
                                                id="departmentId"
                                                :value="departmentId"
                                            />
                                            <input
                                                type="text"
                                                name="departmentName"
                                                :value="departmentName"
                                                class="parentName xc-input xc-input-disabled"
                                                disabled
                                                placeholder="请选择上级部门"
                                            />
                                            <span
                                                class="myDepartment"
                                                @click="selectDepartment"
                                            ><i class="fa fa-align-center"></i> </span>
                                        </div>
                                    </xc-form-item>
                                    <xc-form-item
                                        label="角色名称"
                                        required
                                    >
                                        <input
                                            type="hidden"
                                            name="roleIds"
                                            v-model="current.belongRoleIds"
                                            ref="roleIds"
                                        />
                                        <v-select
                                            class="xc-input roles"
                                            :options="roles"
                                            :value="selected"
                                            @input="getSelected"
                                            :reduce="roleName => roleName.roleId"
                                            label="roleName"
                                            multiple
                                            placeholder="请选择"
                                            :closeOnSelect="false"
                                        ></v-select>
                                        <!--插槽-->
                                    </xc-form-item>

                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item
                                        label="密码："
                                        required
                                    >
                                        <input
                                            type="password"
                                            :value="123456"
                                            name="password"
                                            class="xc-input xc-input-disabled"
                                            disabled
                                        />
                                    </xc-form-item>
                                </div>
                                <xc-form-item label="备注:">
                                    <input
                                        type="text"
                                        name="remark"
                                        class="xc-input"
                                        placeholder="请输入备注"
                                        v-model="current.remark"
                                    >
                                </xc-form-item>
                                <div class="xc-form-inline">
                                    <xc-form-item label="创建时间:">
                                        <input
                                            type="text"
                                            name="addTime"
                                            :value="current.addTime"
                                            class="xc-input xc-input-disabled"
                                            disabled
                                            placeholder=""
                                        >
                                    </xc-form-item>
                                    <xc-form-item label="最后修改时间:">
                                        <input
                                            type="text"
                                            name="updateTime"
                                            :value="current.updateTime"
                                            class="xc-input xc-input-disabled"
                                            disabled
                                        >
                                    </xc-form-item>
                                </div>
                                <div class="xc-form-inline">
                                    <xc-form-item label="操作人:">
                                        <input
                                            type="text"
                                            name="operator"
                                            :value="current.operator"
                                            class="xc-input xc-input-disabled"
                                            disabled
                                        >
                                    </xc-form-item>
                                </div>
                            </form>
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-default"
                                    @click="modalName=null"
                                >取消
                                </button>
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-primary"
                                    @click="editSubmit"
                                >保存
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--重置密码-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='reset'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">重置密码</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            <form
                                class="xc-form"
                                name="reset"
                                data-vv-scope="reset"
                            >
                                <xc-form-item
                                    label="账号:"
                                    required
                                >
                                    <input
                                        type="text"
                                        name="userName"
                                        data-vv-as="账号"
                                        class="xc-input xc-input-disabled"
                                        disabled
                                        v-validate="'required'"
                                        v-model="current.userName"
                                        :class="{'xc-input-error':errors.first('userName','reset')}"
                                    >
                                    <input
                                        type="hidden"
                                        name="userId"
                                        v-model="current.userId"
                                    />
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("userName","reset")}}
                                    </div>
                                </xc-form-item>
                                <xc-form-item
                                    label="密码:"
                                    required
                                >
                                    <!-- <input
                                        type="password"
                                        name="password"
                                        data-vv-as="密码"
                                        class="xc-input"
                                        v-validate="'required|complexPwd'"
                                        :class="{'xc-input-error':errors.first('password','reset')}"
                                    > -->
                                    <div class="password-input-wrapper">
                                        <input
                                            :type="showPassword ? 'text' : 'password'"
                                            name="password"
                                            data-vv-as="密码"
                                            class="xc-input"
                                            v-validate="'required|complexPwd'"
                                            :class="{'xc-input-error':errors.first('password','reset')}"
                                        >
                                        <span class="password-toggle" @click="showPassword = !showPassword">
                                            <i class="fa" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                                        </span>
                                    </div>
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("password","reset")}}
                                    </div>
                                </xc-form-item>
                                <xc-form-item
                                    label="重复密码:"
                                    required
                                >
                                    <!-- <input
                                        type="password"
                                        name="newPwd"
                                        data-vv-as="重复密码"
                                        class="xc-input"
                                        v-validate="'required|complexPwd'"
                                        :class="{'xc-input-error':errors.first('newPwd','reset')}"
                                    > -->
                                    <div class="password-input-wrapper">
                                        <input
                                            :type="showNewPwd ? 'text' : 'password'"
                                            name="newPwd"
                                            data-vv-as="重复密码"
                                            class="xc-input"
                                            v-validate="'required|complexPwd|confirmPwd'"
                                            :class="{'xc-input-error':errors.first('newPwd','reset')}"
                                        >
                                        <span class="password-toggle" @click="showNewPwd = !showNewPwd">
                                            <i class="fa" :class="showNewPwd ? 'fa-eye-slash' : 'fa-eye'"></i>
                                        </span>
                                    </div>
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("newPwd","reset")}}
                                    </div>
                                </xc-form-item>
                            </form>
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="resetSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--启用-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='active'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">启用</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定启用该用户？
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="enableSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--禁用-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='disabled'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">禁用</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定禁用该用户？禁用后该账号不能使用
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="disabledSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--删除-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='delete'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">删除</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定删除该用户？
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="deleteSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--登录解锁-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='unlock'">
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">登录解锁</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定解锁该用户的登录锁定？
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="unlockSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="xc-modal xc-model-dialog"
            v-if="modalName=='setPower'">
                <div class="xc-modal-mask" @click="modalName = null"></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content content-wrap">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">设置分组权限</div>
                            <div class="xc-modal-close" @click="modalName = null"></div>
                        </div>
                        <div class="xc-modal-body">
                             <xc-tree
                                :data.sync="deviceGroups"
                                label="name"
                                :expand="0"
                                show-checkbox
                                multiple
                                linked
                                :type="1"
                                @init="initGroup"
                                @checked="selectGroup">
                            </xc-tree>
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-default"
                                    @click="modalName=null"
                                >取消
                                </button>
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-primary"
                                    @click="submitModel"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listMixin from '../xc-ui/mixins/list';
import "@/libs/font-awesome"
import "@/libs/vee-validate"
import "@/libs/vue-select"
import "@/utils/form-format"
import { getList, getTree } from "../api/department";
import role from "@/api/role"
import user from "@/api/user"
import myLayerImport from '@/libs/myLayer';
import loadScript from "../utils/load-script";

// ip格式化
import "@/utils/ip-format";

myLayerImport();

export default {
    name: 'departmentList',
    mixins: [listMixin],
    data() {
        return {
            deviceGroups:[],    //播控助手树。
            deviceGroupIds:"",
            selected: [],
            values: [],  //角色id
            adminPath: this.$config.adminPath,
            // 列表key
            mix_listKey: 'list',

            // 列表唯一字段
            mix_listId: 'id',

            list: [],
            stores: [], //门店列表
            roles: [],   //角色列表
            departments: [], //部门列表

            // 默认查询参数
            mix_query: {
                departmentId: "",
                mobile: "",
                userName: "",
                realName: "",
                roleName: ""
            },
            group: [
                {
                    name: "编辑",
                    id: 0
                },
                {
                    name: "重置密码",
                    id: 1,
                },
                {
                    name: "启用",
                    id: 2,
                },
                {
                    name: "禁用",
                    id: 3,
                },
                {
                    name: "删除",
                    id: 4
                },
                {
                    name: "登录解锁",
                    id: 5
                }
            ],
            //为播控助手时的操作
            power: [
                {
                    name: "编辑",
                    id: 0
                },
                {
                    name:"设置分组权限",
                    id: 1,
                },
                {
                    name: "重置密码",
                    id: 2,
                },
                {
                    name: "启用",
                    id: 3,
                },
                {
                    name: "禁用",
                    id: 4,
                },
                {
                    name: "删除",
                    id: 5,
                }
            ],
            modalName: null,  //弹窗名称,add表示添加\edit表示编辑
            current: null,   //当前表行
            departmentName: "",
            departmentId: "",
            showPassword: false,  //密码框显示状态
            showNewPwd: false,    //确认密码框显示状态
            showAddPassword: false //新增账号密码框显示状态
        }
    },
    computed: {},
    filters: {
        getStatus: function (value) {
            if (value == 0) {
                return "禁用"
            }
            return "启用";
        }
    },
    methods: {
        //请求树
        getTree(userId){
            user.getDeviceGroups(userId).then(ret => {
                this.deviceGroups = ret.data;    
            })
        },
        //遍历选中的终端组,返回新数组
        getChecked(data){
           return data.map(v => {
               return v.id
           })
        },
        //    确认
        submitModel(){
            var options={
                deviceGroupIds:this.deviceGroupIds,
                userId:this.current.userId
            };
            user.saveGroups(options).then(v=>{
                this.$message.success("操作成功");
                this.modalName=null;
            })
        },
        // 初始化数据
        initData() {
            var _this = this;
            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query,
            }

            //请求列表数据
            user.userList(search).then(function (ret) {
                //添加mix_checkbox属性
                _this.list = _this.mix_format(ret.data.list);
                _this.mix_total = ret.data.total;
                _this.mix_page = ret.data.pageNum;
                _this.mix_pageSize = ret.data.pageSize;
            }).catch(function (error) {
                console.log(error)
            });
        },
        //初始化分组
        initGroup(data){
            var arr0=this.getChecked(data.checked);
            this.deviceGroupIds=arr0.join(",");
        },
        selectGroup(data){
            var arr0=this.getChecked(data.checked);
            this.deviceGroupIds=arr0.join(",");
        },
        // 更新分页
        pageChange: function (page, pageSize) {
            this.mix_page = page;
            this.mix_pageSize = pageSize;
            this.initData();
        },
        // 打开添加弹窗
        add() {
            this.modalName = "add";
            this.departmentName = "";
            this.departmentId = "";
            this.values = [];
        },
        selectDepartment: function () {
            var _this = this;
            myLayer.open({
                type: 2,
                title: false,
                closeBtn: 0,
                content: this.adminPath + "/system/department/select",
                // content: this.adminPath + "/system/department/select?currentId=82",
                success: function (layero, index) {
                    //    声明一个全局函数
                    window.init = function (name, id) {

                        _this.departmentName = name;
                        _this.departmentId = id;
                    }
                }
            })
        },
        // 操作单条数据
        action(...args) {
            var _this = this;
            const [action, item, index] = args;
            const e = args[args.length - 1];
            this.current = { ...item };
            console.log(111,item);
            switch (action.name) {
                case "编辑":
                    this.modalName = "edit";
                    this.selected = this.current.belongRoleIds.split(",").map((item, index) => {
                        return { roleId: item, roleName: this.current.belongRole.split(",")[index] }
                    });
                    this.departmentName = this.current.departmentName;
                    this.departmentId = this.current.departmentId;
                    break;
                case "重置密码":
                    //打开弹窗
                    this.modalName = "reset";
                    break;
                case "启用":
                    this.modalName = "active";
                    break;
                case "禁用":
                    this.modalName = "disabled";
                    break;
                case "删除":
                    this.modalName = "delete";
                    break;
                case "设置分组权限":
                    this.getTree(item.userId);
                    this.modalName = "setPower";
                    break;
                case "登录解锁":
                    this.modalName = "unlock";
                    break;
                default:
                    break;
            }
        },
        groups: function (item) {
            var arr = this.group.slice(0);
            if (item.status == 0) {
                //1表示正常,0表示禁用
                arr.splice(3, 1);
            } else {
                arr.splice(2, 1)
            }
            return arr;
        },
        //播控助手设置权限
        powers: function (item) {
            var arr = this.power.slice(0);
            if (item.status == 0){
                //1表示正常,0表示禁用
                arr.splice(4, 1);
            } else {
                arr.splice(3, 1);
            }
            return arr;
        },
        // 添加确定
        addSubmit: function () {
            var myForm = document.add;
            // 验证器命名空间
            const scope = 'add';

            this.$validator.validateAll(scope).then(validate => {
                if (validate) {
                    if (this.values.length > 0) {
                        const data = this.$formFormat(myForm);
                        data.roleIds = this.values.join(",");

                        var verifyResult = this.checkPassword(data.password);
                        if (verifyResult != true) {
                            this.$message.error(verifyResult);
                            return false;
                        }

                        data.password = md5(data.password)


                        user.save(data).then((success) => {
                            this.$message.success("添加成功");
                            this.modalName = null;
                            this.initData();
                        })
                    } else {
                        this.$message.error("请选择角色");
                        return false;
                    }
                } else {
                    let error = this.errors.items[0].msg;
                    return false;
                }
            })
        },
        getSelected(value) {
            this.current.belongRoleIds = value.join(",");
        },
        //    编辑确定
        editSubmit: function () {
            var myForm = document.edit;
            // 验证器命名空间
            const scope = 'edit';

            this.$validator.validateAll(scope).then(validate => {
                if (validate) {
                    var formData = this.$formFormat(myForm);
                    return formData;
                }
            }).then(formData => {
                formData.password = md5(formData.password)

                if (formData) {
                    if (formData.roleIds == "") {
                        this.$message.error("请选择角色");
                        return;
                    }
                    user.update(formData).then((success) => {
                        this.$message.success('修改成功');
                        this.modalName = null;
                        this.initData();
                    })
                }
            })

        },
        //冻结确定
        freezeSubmit: function () {

        },
        //解冻
        unfreezeSubmit: function () {

        },
        //    禁用确定
        disabledSubmit: function () {
            var _this = this;
            var obj = {
                userId: this.current.userId,
                status: 0
            };
            user.enableDisableUser(obj).then(function (success) {
                _this.$message.success("禁用成功");
                _this.modalName = null;
                _this.initData();
            }).catch(function (error) {
                console.log(error)
            })
        },
        //启用确定
        enableSubmit: function () {
            var _this = this;
            var obj = {
                userId: this.current.userId,
                status: 1
            };
            user.enableDisableUser(obj).then(function (success) {
                _this.$message.success("启用成功");
                _this.modalName = null;
                _this.initData();
            }).catch(function (error) {
                console.log(error)
            })
        },
        // 重置密码确定
        resetSubmit: function () {
            var myForm = document.reset;
            // 验证器命名空间
            const scope = 'reset';

            this.$validator.validateAll(scope).then(validate => {
                if (validate) {

                    var data = this.$formFormat(myForm);

                    var verifyResult = this.checkPassword(data.password);
                    if (verifyResult != true) {
                        this.$message.error(verifyResult);
                        return false;
                    }

                    if (data.password != data.newPwd) {
                        this.$message.error("两次输入密码不一致");
                        return false;
                    }

                    

                    data.password = md5(data.password);
                    data.newPwd = md5(data.newPwd);

                    return data;
                } else {
                    let error = this.errors.items[0].msg;
                    return false;
                }
            }).then(formData => {
                if (formData) {
                    user.resetPassword(formData).then((success) => {
                        this.$message.success("重置密码成功");
                        this.modalName = null;
                        this.initData();
                    })
                }
            })
        },
        // 删除确认
        deleteSubmit() {
            var obj = {
                userId: this.current.userId
            };
            user.delete(obj).then(v => {
                this.$message.success(v.msg);
                this.modalName = null;
                this.initData()
            })
        },
        // 解锁确认
        unlockSubmit() {
            var obj = {
                userId: this.current.userId
            };
            user.unlock(obj).then(v => {
                this.$message.success(v.msg);
                this.modalName = null;
                this.initData()
            })
        },
        /**
       * 密码验证
       * @param {String} 密码
       */
        checkPassword(v) {
            var numasc = 0;
            var charasc = 0;
            var otherasc = 0;
            if (0 == v.length) {
                return "密码不能为空";
            } else if (v.length < 6 || v.length > 20) {
                return "密码长度为6-20位，且同时包含数据和字母";
            } else {
                for (var i = 0; i < v.length; i++) {
                    var asciiNumber = v.substr(i, 1).charCodeAt();
                    if (asciiNumber >= 48 && asciiNumber <= 57) {
                        numasc += 1;
                    }
                    if ((asciiNumber >= 65 && asciiNumber <= 90) || (asciiNumber >= 97 && asciiNumber <= 122)) {
                        charasc += 1;
                    }
                    if ((asciiNumber >= 33 && asciiNumber <= 47) || (asciiNumber >= 58 && asciiNumber <= 64) || (asciiNumber >= 91 && asciiNumber <= 96) || (asciiNumber >= 123 && asciiNumber <= 126)) {
                        otherasc += 1;
                    }
                }
                if (0 == numasc || 0 == charasc) {
                    return "密码长度为6-20位，且同时包含数据和字母";
                } else {
                    return true;
                }
            }
        }
    },
    created() {
        loadScript("/libs/md5.js");

        // 请求部门列表
        getList({ departmentName: "", status: "" }).then((success) => {
            this.departments = success.data.list;
        })
        // 请求角色列表
        role.listRoleSelect().then((success) => {
            this.roles = success.data;
        })
    }
}
</script>

<style  lang="scss">
@import "../xc-ui/scss/variable";
.reset {
    form[name="reset"] {
        .xc-form-item-label {
            width: 80px;
        }
    }

    .password-input-wrapper {
        position: relative;
        .password-toggle {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
            color: #999;
            font-size: 14px;
            &:hover {
                color: #006ebc;
            }
        }
    }

    .department {
        position: relative;
        .myDepartment {
            position: absolute;
            top: 0;
            right: 0;
            border-radius: 0 5px 5px 0;
            cursor: pointer;
            box-shadow: -1px 0 2px 0 #bbb;
            width: 32px;
            line-height: 32px;
            text-align: center;
        }
    }
    .roles {
        .vs__search,
        .vs__selected,
        .vs__dropdown-option {
            color: #808b9e;
        }
        .vs__dropdown-menu {
            max-height: 200px;
        }
        .vs__dropdown-option--highlight {
            background: $xc-bg;
            color: #ffffff;
        }
    }
}
.content-wrap{
    height:610px;
    width:1010px;
}
</style>

